// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, Input } from "@angular/core";

@Component({
    selector: "menu-bar",
    standalone: false,
    templateUrl: "./menu-bar.component.html",
    styleUrl: "./menu-bar.component.css"
})
export class MenuBarComponent {
    @Input('menuItems') menuItems: any[] = [];
}